/**
 * The BlobBuilder class is used to generate blob objects.
 */
export class BlobBuilder {
    private blob = new Blob();

    /**
    * Appends new value to blob.
    */
    append(value: any) {
        this.blob = new Blob([this.blob, value]);
    }

    /**
    * Gets generated blob.
    */
    build(): Blob {
        return this.blob;
    }
}
